import { useEffect, useRef, useState } from 'react'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import { findOrgByName } from '@/actions'

import './OrganizationTypeahead.css'

const OrganizationTypeahead = ({ className, orgName, setOrgName }) => {
    
    const [isLoading, setIsLoading] = useState(false)
    const [options, setOptions] = useState([])
    const typeaheadRef = useRef()
    
    const handleSearch = async term => {
        setIsLoading(true)
        setOrgName(term)
        const orgs = await findOrgByName(term)
        
        setOptions(orgs.map(o => o.name))
        setIsLoading(false)
    }
    
    // hacky way to clear the input when the state is cleared
    useEffect(() => {
        
        if (!orgName?.length)
            typeaheadRef.current.clear()
        
    }, [orgName])
    
    return (
        <AsyncTypeahead
            ref={typeaheadRef}
            id="join-org-settings"
            className="org-typeahead"
            inputProps={{
                className: `${className} input input-bordered w-full`,
            }}
            filterBy={() => true}
            isLoading={isLoading}
            minLength={3}
            delay={300}
            onSearch={handleSearch}
            onBlur={e => setOrgName(e.target.value)}
            onChange={value => setOrgName(value[0] || '')}
            options={options}
            placeholder="Search..."/>
    )
}

export default OrganizationTypeahead
